import config from "react-global-configuration";

export const getScreens = () =>
  fetch(`${config.get("ApiUrl").Rest}/tests`, {
    mode: "cors",
    credentials: "include",
  });

export const getCrops = () =>
  fetch(`${config.get("ApiUrl").Rest}/crops`, {
    mode: "cors",
    credentials: "include",
  });

export const generateCommodityDetectionReport = (data) =>
  fetch(`${config.get("ApiUrl").Rest}/export/report-commodity-detection`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
    mode: "cors",
    credentials: "include",
  });
